import { ThemeContext } from "contexts";
import React, { useState } from "react";

type RelatedQuestionsProps = {
  questions: string[];
  onClick: (question: string) => void;
};

const RelatedQuestions: React.FC<RelatedQuestionsProps> = ({
  questions,
  onClick,
}) => {
  const theme = React.useContext(ThemeContext);

  const [hoveredButton, setHoveredButton] = useState<string | null>(null);
  const [selectedButton, setSelectedButton] = useState<string | null>(null);

  React.useEffect(() => {
    setSelectedButton(null);
  }, [questions]);

  const handleMouseEnter = (question: string) => {
    setHoveredButton(question);
  };

  const handleMouseLeave = () => {
    setHoveredButton(null);
  };

  return (
    <div style={styles.container}>
      {questions.map((question, index) => (
        <button
          key={index}
          disabled={selectedButton !== null}
          onClick={() => {
            onClick(question);
            setSelectedButton(question);
          }}
          onMouseEnter={() => handleMouseEnter(question)}
          onMouseLeave={handleMouseLeave}
          style={{
            ...styles.button,
            ...(hoveredButton === question || selectedButton === question
              ? {
                  color: theme?.themeColor,
                  border: `1px solid ${theme?.themeColor}`,
                }
              : {}),
            cursor: selectedButton !== null ? "not-allowed" : "pointer",
          }}
        >
          {question}
        </button>
      ))}
    </div>
  );
};

const styles = {
  button: {
    padding: "6px 16px",
    fontSize: 16,
    textAlign: "center",
    color: "#212121",
    fontWeight: "bold",
    cursor: "pointer",
    borderRadius: "20px",
    border: "1px solid #868B97",
    boxShadow: "0px 2px 8px 0px rgba(4, 6, 15, 0.20)",
    backgroundColor: "#FFFFFF",
    transition: "color 0.4s ease, border 0.4s ease",
  },
  container: {
    gap: 5,
    display: "flex",
    flexWrap: "wrap",
    marginLeft: "auto",
    justifyContent: "flex-end",
  },
} as const;

export default RelatedQuestions;
